import styles from '../styles/Footer.module.css';
import { useState } from "react";
import AGBModal from "./modals/AGB";
import ImpressumModal from "./modals/Impressum";

const Footer = () => {
    const [showAGB, setShowAGB] = useState(false);
    const [showImpressum, setShowImpressum] = useState(false);

    return (
        <footer className={styles.footer}>
            <span>© {new Date().getFullYear()} Dreamgarage</span>
            <span className={styles.separator}>|</span>
            <span
                className={styles.agbLink}
                onClick={() => setShowAGB(true)}
            >
                AGB / Bedingungen
            </span>
            <span className={styles.separator}>|</span>
            <span
                className={styles.agbLink}
                onClick={() => setShowImpressum(true)}
            >
                Impressum
            </span>

            {showAGB && <AGBModal close={() => setShowAGB(false)} />}
            {showImpressum && <ImpressumModal close={() => setShowImpressum(false)} />}
        </footer>
    );
};

export default Footer;